export const CivilServicesRoomDetails = [
  {
    id: 'wall_construction',
    label: 'Wall Construction',
    options: ['Yes']
  },
  {
    id: 'pop_wall_punning',
    label: 'POP Wall Punning',
    options: ['Yes']
  },
  {
    id: 'cement_plastering_on_wall_repair',
    label: 'Cement Plastering on Wall / Repair',
    options: ['Yes']
  },
  {
    id: 'pop_ceiling_punning',
    label: 'POP Ceiling Punning',
    options: ['Yes']
  },
  {
    id: 'core_cutting',
    label: 'Core Cutting',
    options: ['Yes']
  },
  {
    id: 'pcc_leveling_construction',
    label: 'PCC leveling / construction',
    options: ['Yes']
  },
  {
    id: 'tile_granite_walls',
    label: 'Tile / Granite / Quartz installation for Walls',
    options: ['Yes']
  },
  {
    id: 'puncture_hole_countertop',
    label: 'Puncture Hole for countertop',
    options: ['Yes']
  },
  {
    id: 'tile_installation_floor',
    label: 'Tile Installation for Floor',
    options: ['Yes']
  },
  {
    id: 'waterproofing',
    label: 'Waterproofing',
    options: ['Yes']
  },
  {
    id: 'tile_installation_skirting',
    label: 'Tile Installation for Skirting',
    options: ['Yes']
  },
  {
    id: 'epoxy_grouting_tile_installation',
    label: 'Epoxy Grouting for Tile Installation',
    options: ['Yes']
  },
];

export const CivilFloorMarbleLayingDetails = [
  {
    id: 'marble_supply',
    label: 'Marble Supply',
    options: ['Customer', 'HomeLane']
  },
  {
    id: 'marble_laying',
    label: 'Marble Laying',
    options: ['Customer', 'HomeLane']
  },
  {
    id: 'marble_polishing',
    label: 'Marble Polishing',
    options: ['Customer', 'HomeLane']
  },
  {
    id: 'skirting_height',
    label: 'Skirting Height',
    type: 'input'
    // options: ['Customer', 'HomeLane']
  },
];

export const CivilFloorTilesLayingDetails = [
  {
    id: 'floor_tile_supply',
    label: 'Floor Tile Supply',
    options: ['Customer', 'HomeLane']
  },
  {
    id: 'floor_tile_installation',
    label: 'Floor Tile Installation',
    options: ['Customer', 'HomeLane']
  },
  {
    id: 'epoxy_grouting',
    label: 'Epoxy Grouting',
    options: ['Yes', 'No']
  },
];

export const CivilWallTilesLayingDetails = [
  {
    id: 'wall_tile_supply',
    label: 'Wall Tile Supply',
    options: ['Customer', 'HomeLane']
  },
  {
    id: 'wall_tile_installation',
    label: 'Wall Tile Installation',
    options: ['Customer', 'HomeLane']
  },
  {
    id: 'epoxy_grouting',
    label: 'Epoxy Grouting',
    options: ['Yes', 'No']
  },
];


export const DummyCivilWorkDetails = [
  {
    name: 'Laying of New Flooring - Indian Marble',
    qty: '120',
    uom: 'Rft'
  },
]

export const customCivilMarbleFlooring = [
  {
    id: 'service_name',
    type: 'input'
  },
  {
    id: 'service_quantity',
    type: 'input'
  },
  {
    id: 'service_uom',
    type: 'input'
  },
]